// extracted by mini-css-extract-plugin
module.exports = {"page":"supply-and-scheduling__ClinicianCalendarPage__page","calendar":"supply-and-scheduling__ClinicianCalendarPage__calendar"};